/**
 * MİLYEMSOFT açılış ekranı — sayfa yüklenirken tam ekran siyah zeminde
 * altın MS monogramı stroke-dasharray animasyonu ile çizilir. Lüks saat
 * markası ambalajı hissi. Prop `visible=false` iken fade-out.
 */
export default function LoadingScreen({ visible = true }) {
  return (
    <div
      data-testid="loading-screen"
      className={`fixed inset-0 z-[200] flex flex-col items-center justify-center bg-black transition-opacity duration-500 ${visible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
    >
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle at 50% 45%, rgba(212,175,55,0.08) 0%, transparent 55%)",
        }}
      />

      <svg viewBox="0 0 64 64" width="128" height="128" className="relative">
        <defs>
          <linearGradient id="loadLux" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#E6C15E" />
            <stop offset="60%" stopColor="#C89B2B" />
            <stop offset="100%" stopColor="#A47F1E" />
          </linearGradient>
        </defs>

        {/* Hairline çerçeve — hemen fade in */}
        <circle
          cx="32" cy="32" r="29"
          fill="none"
          stroke="url(#loadLux)"
          strokeWidth="0.6"
          opacity="0.55"
          className="ms-ring"
        />

        {/* M ve S monogramı — soldan sağa stroke-dasharray çizim */}
        <g fill="none" stroke="url(#loadLux)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path
            d="M 13 46 L 13 20 L 22 34 L 31 20 L 31 46"
            className="ms-draw ms-draw-m"
          />
          <path
            d="M 51 22 C 51 19, 46 18, 42 18 C 37 18, 34 21, 34 25 C 34 30, 40 30, 45 32 C 50 34, 51 37, 51 40 C 51 44, 47 46, 43 46 C 39 46, 34 45, 34 42"
            className="ms-draw ms-draw-s"
          />
        </g>

        <circle
          cx="55" cy="12" r="1.1"
          fill="url(#loadLux)"
          className="ms-dot"
        />
      </svg>

      <div
        className="mt-6 font-display text-2xl tracking-[0.35em] ms-title"
        style={{
          background: "linear-gradient(180deg, #E6C15E 0%, #C89B2B 60%, #A47F1E 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        MİLYEMSOFT
      </div>
      <div className="mt-2 text-[10px] font-mono tracking-widest text-neutral-500 ms-subtitle">
        MARKA & YAZILIM · YÜKLENİYOR
      </div>

      <style>{`
        .ms-ring { opacity: 0; animation: ms-fadein 0.4s ease-out 0s forwards; }
        .ms-draw { stroke-dasharray: 120; stroke-dashoffset: 120; }
        .ms-draw-m { animation: ms-write 0.9s ease-out 0.25s forwards; }
        .ms-draw-s { animation: ms-write 1.1s ease-out 0.75s forwards; }
        .ms-dot { opacity: 0; animation: ms-pop 0.4s ease-out 1.65s forwards; }
        .ms-title { opacity: 0; transform: translateY(6px); animation: ms-rise 0.6s ease-out 1.55s forwards; }
        .ms-subtitle { opacity: 0; animation: ms-fadein 0.5s ease-out 1.85s forwards; }
        @keyframes ms-write { to { stroke-dashoffset: 0; } }
        @keyframes ms-fadein { from { opacity: 0; } to { opacity: 0.55; } }
        @keyframes ms-pop { from { opacity: 0; transform: scale(0.4); transform-origin: 55px 12px; } to { opacity: 1; transform: scale(1); } }
        @keyframes ms-rise { to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
}
